import { FC } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { MailIcon } from 'ui/components/icon';
import { cn } from 'utils/helpers';

interface PROPS {
  emailAddress: string;
}

const Success: FC<PROPS> = ({ emailAddress }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-fill-tertiary rounded-[6px] w-[600px] py-8 shadow-leapify-sm">
      <img
        alt="Leapify Logo"
        className="w-[170px] mb-[55px] block mx-auto"
        src={leapifyLogo}
      />
      <div className="max-w-[428px] mx-auto">
        <h3 className={cn('mb-[16px]', 'text-center', 'text-xl font-semibold')}>
          Reset your password
        </h3>
        <p className="text-sm text-center mb-[44px]">
          Please enter the email address you’d like your password reset
          infomation sent to.
        </p>
        <div className="mb-10 flex flex-col items-center">
          <MailIcon className="w-[100px] h-[100px] text-primary-base" />
        </div>
        <h3 className={cn('mb-[16px]', 'text-center', 'text-xl font-semibold')}>
          Check your email
        </h3>
        <p className="text-sm text-center mb-[44px]">
          We have sent a password recover instructions to your account email for{' '}
          <span className="font-bold">{emailAddress}</span>
        </p>
        <Button
          label="GO BACK TO LOGIN"
          type="submit"
          className="w-full font-semibold mb-[15px]"
          onClick={() => navigate('/')}
          intent="tertiary"
          size="lg"
        />
      </div>
    </div>
  );
};

export default Success;
